const formatDateTime = (dateString: string) => {
  const [datePart, timePart] = dateString.split(" ");

  const [day, month, year] = datePart.split("/").map(Number);

  const [hour, minute] = timePart.split(":").map(Number);

  const dateObject = new Date(year, month - 1, day, hour, minute);

  if (isNaN(dateObject.getTime())) {
    throw new Error("Chuỗi không hợp lệ!");
  }

  const fullYear = dateObject.getFullYear();
  const monthOfYear = dateObject.getMonth() + 1;
  const dayOfMonth = dateObject.getDate();
  const hourOfDay = dateObject.getHours();
  const minuteOfHour = dateObject.getMinutes();
  return {
    fullYear: fullYear,
    monthOfYear: monthOfYear,
    dayOfMonth: dayOfMonth,
    hourOfDay: hourOfDay,
    minuteOfHour: minuteOfHour,
  };
};

export const formatDate = (datePart: string) => {
  const [day, month, year] = datePart.split("/").map(Number);

  const dateObject = new Date(year, month - 1, day);

  if (isNaN(dateObject.getTime())) {
    throw new Error("Chuỗi không hợp lệ!");
  }

  const fullYear = dateObject.getFullYear();
  const monthOfYear = dateObject.getMonth() + 1;
  const dayOfMonth = dateObject.getDate();
  return {
    fullYear: fullYear,
    monthOfYear: monthOfYear,
    dayOfMonth: dayOfMonth,
  };
};

export default formatDateTime;
